import fetcher from '../../utils/fetcher'
import localSave from '../../utils/localSave'
import { ResponseData } from './types'

export interface CaptchaResponse {
  code: number
  msg: string
}

interface GetCaptchaParams {
  yzm: string
  mobile: string | number
}

export interface LoginResponse {
  token: string
  headerimg: string
}

interface LoginParams {
  yzm: string
  mobile: string | number
  code: string | number
}


export default function useLogin() {
  /**
   * 获取短信验证码
   * @param params 验证码参数
   */
  const getCaptcha = async (params: GetCaptchaParams)=>{
    const res: CaptchaResponse = await fetcher.get(`/sms.php?yzm=${params.yzm}&mobile=${params.mobile}`)
    return res.code === 1
  }

  const login = async (params: LoginParams)=>{
    const res: ResponseData<LoginResponse> = await fetcher.get(`/login.php?yzm=${params.yzm}&mobile=${params.mobile}&code=${params.code}`)

    if(res.success) {
      localSave.set('token', res.data.token) // 保存到localstorage
      localSave.set('avatar', res.data.headerimg) // 保存到localstorage
      return res.data
    }else {
      return false
    }
  }

  return {
    getCaptcha,
    login
  }

}
